
const formatter = n => {
  const ranges = [
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" }
  ];

  for (let i = 0; i < ranges.length; i++) {
    if (n >= ranges[i].divider) {
      return (
        (Math.round(n) / ranges[i].divider).toFixed(2).toString() +
        ranges[i].suffix
      );
    }
  }

  const r = new Intl.NumberFormat("pt-BR", {style: "decimal", maxDigits: 2}).format(n);

  return r == 0 ? "" : r;
}

export default formatter
